var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-form-item",
    { attrs: { label: _vm.name, prop: _vm.code, rules: _vm.rules } },
    [
      _c(
        "el-select",
        {
          attrs: {
            disabled: _vm.disabled,
            placeholder: " -- 请选择 -- ",
            clearable: true,
          },
          on: { change: _vm.change },
          model: {
            value: _vm.val,
            callback: function ($$v) {
              _vm.val = $$v
            },
            expression: "val",
          },
        },
        _vm._l(_vm.options, function (item) {
          return _c("el-option", {
            key: item[_vm.keyField],
            attrs: { label: item[_vm.valueField], value: item[_vm.keyField] },
          })
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }